import React, { useState } from 'react';
import { toOption } from '@grafana/data';
import { useStyles2, Select, Field, Button } from '@grafana/ui';
import { css } from '@emotion/css';
import { ControlsLabel } from '../../utils/ControlsLabel.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
function AdHocFilterRenderer({ filter, model }) {
  var _a, _b;
  const styles = useStyles2(getStyles);
  const [state, setState] = useState({});
  const keyValue = filter.key !== "" ? toOption(filter.key) : null;
  const valueValue = filter.value !== "" ? toOption(filter.value) : null;
  const valueSelect = /* @__PURE__ */ React.createElement(Select, {
    disabled: model.state.readOnly,
    className: state.isKeysOpen ? styles.widthWhenOpen : void 0,
    width: "auto",
    value: valueValue,
    placeholder: "value",
    options: state.values,
    onChange: (v) => model._updateFilter(filter, "value", v.value),
    isOpen: state.isValuesOpen,
    isLoading: state.isValuesLoading,
    onOpenMenu: async () => {
      setState(__spreadProps(__spreadValues({}, state), { isValuesLoading: true }));
      const values = await model._getValuesFor(filter);
      setState(__spreadProps(__spreadValues({}, state), { isValuesLoading: false, isValuesOpen: true, values }));
    },
    onCloseMenu: () => {
      setState(__spreadProps(__spreadValues({}, state), { isValuesOpen: false }));
    }
  });
  const keySelect = /* @__PURE__ */ React.createElement(Select, {
    disabled: model.state.readOnly,
    className: state.isKeysOpen ? styles.widthWhenOpen : void 0,
    width: "auto",
    value: keyValue,
    placeholder: "Select label",
    options: state.keys,
    onChange: (v) => model._updateFilter(filter, "key", v.value),
    autoFocus: filter.key === "",
    isOpen: state.isKeysOpen,
    isLoading: state.isKeysLoading,
    onOpenMenu: async () => {
      setState(__spreadProps(__spreadValues({}, state), { isKeysLoading: true }));
      const keys = await model._getKeys(filter.key);
      setState(__spreadProps(__spreadValues({}, state), { isKeysLoading: false, isKeysOpen: true, keys }));
    },
    onCloseMenu: () => {
      setState(__spreadProps(__spreadValues({}, state), { isKeysOpen: false }));
    },
    openMenuOnFocus: true
  });
  if (model.state.layout === "vertical") {
    if (filter.key) {
      const label = /* @__PURE__ */ React.createElement(ControlsLabel, {
        layout: "vertical",
        label: (_a = filter.key) != null ? _a : "",
        onRemove: () => model._removeFilter(filter)
      });
      return /* @__PURE__ */ React.createElement(Field, {
        label,
        "data-testid": `AdHocFilter-${filter.key}`,
        className: styles.field
      }, valueSelect);
    } else {
      return /* @__PURE__ */ React.createElement(Field, {
        label: "Select label",
        "data-testid": `AdHocFilter-${filter.key}`,
        className: styles.field
      }, keySelect);
    }
  }
  return /* @__PURE__ */ React.createElement("div", {
    className: styles.wrapper,
    "data-testid": `AdHocFilter-${filter.key}`
  }, keySelect, /* @__PURE__ */ React.createElement(Select, {
    value: filter.operator,
    disabled: model.state.readOnly,
    options: model._getOperators(),
    width: "auto",
    onChange: (v) => model._updateFilter(filter, "operator", v.value)
  }), valueSelect, /* @__PURE__ */ React.createElement(Button, {
    variant: "secondary",
    "aria-label": "Remove filter",
    title: "Remove filter",
    className: styles.removeButton,
    icon: "times",
    "data-testid": `AdHocFilter-remove-${(_b = filter.key) != null ? _b : ""}`,
    onClick: () => model._removeFilter(filter)
  }));
}
const getStyles = (theme) => ({
  field: css({
    marginBottom: 0
  }),
  wrapper: css({
    display: "flex",
    "> *": {
      "&:not(:first-child)": {
        marginLeft: -1
      },
      "&:first-child": {
        borderTopRightRadius: 0,
        borderBottomRightRadius: 0
      },
      "&:last-child": {
        borderTopLeftRadius: 0,
        borderBottomLeftRadius: 0
      },
      "&:not(:first-child):not(:last-child)": {
        borderRadius: 0
      },
      position: "relative",
      zIndex: 0,
      "&:hover": {
        zIndex: 1
      },
      "&:focus-within": {
        zIndex: 2
      }
    }
  }),
  widthWhenOpen: css({
    minWidth: theme.spacing(16)
  }),
  removeButton: css({
    paddingLeft: theme.spacing(3 / 2),
    paddingRight: theme.spacing(3 / 2),
    borderLeft: "none",
    position: "relative",
    left: "1px"
  })
});

export { AdHocFilterRenderer };
//# sourceMappingURL=AdHocFilterRenderer.js.map
